<template>
    <div class="bs-container">
        <el-row v-show="datasetType === null" type="flex" class="layout">
            <div id="left-box" class="left-box" :style="{ transition: transition + 's' }">
                <div class="inner-container">
                    <TypeTree ref="datasetsTypeTree" :dataset-type-list="datasetTypeList" :app-code="appCode"
                        @nodeClick="nodeClick" @refreshData="refreshData" @expandedNodes="expandedNodes" />
                </div>
            </div>
            <div class="right-box inner-container" :style="{ transition: transition + 's' }">
                <el-form ref="queryForm" :model="queryForm" class="filter-container bs-el-form" @submit.native.prevent>
                    <el-form-item class="filter-item" prop="dataSetName">
                        <el-input v-model="queryForm.dataSetName" class="bs-el-input" placeholder="请输入数据集名称" clearable
                            @keyup.enter.native="handleSearch()" @clear="handleSearch()" />
                    </el-form-item>
                    <el-form-item class="filter-item">
                        <el-button :loading="dataListLoading" size="mini" type="primary" icon="el-icon-search"
                            @click="handleSearch()">
                            查询
                        </el-button>
                    </el-form-item>
                    <el-form-item class="filter-item">
                        <el-button v-if="toAdd" class="bs-el-button-default" size="mini" @click="addDataset">
                            新增
                        </el-button>
                    </el-form-item>
                </el-form>
                <div class="dataroom-table-box">
                    <el-table ref="userTable" v-loading="dataListLoading" border v-if="isDialog && !multiple"
                        :element-loading-text="loadingText" :data="tableData" :header-cell-style="sortStyle"
                        @sort-change="reSort" @current-change="handleCurrentChange" @select="selectDs"
                        @select-all="selectAll">
                        <el-empty slot="empty" />
                        <el-table-column prop="dataSetName" label="数据集名称" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-radio v-model="curRow" :label="scope.row">
                                    {{ scope.row.dataSetName }}
                                </el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" label="数据集类型" show-overflow-tooltip>
                        </el-table-column>
                        <!-- <el-table-column prop="labelCode" label="标签" align="center" show-overflow-tooltip>
                        </el-table-column> -->
                        <el-table-column prop="remark" label="备注" show-overflow-tooltip />
                        <!--操作栏-->
                        <el-table-column label="操作" width="200">
                            <template v-if="showOperate(scope.row.type)" slot-scope="scope">
                                <el-button type="text" v-if="doEdit" class="bs-el-button-default"
                                    :disabled="scope.row.editable === 1 && !appCode" @click="
                                        toEdit(
                                            scope.row.id,
                                            scope.row.type,
                                            scope.row.dataSetName,
                                        )
                                        ">
                                    编辑
                                </el-button>
                                <el-button type="text" v-if="isDelete" class="bs-el-button-default"
                                    :loading="scope.row.loading" :disabled="scope.row.editable === 1 && !appCode"
                                    @click="delDataset(scope.row)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-table ref="userTable" v-loading="dataListLoading" border :height="tabmaxheight" v-else
                        :element-loading-text="loadingText" :data="tableData" :header-cell-style="sortStyle"
                        @sort-change="reSort" @current-change="handleCurrentChange" @select="selectDs"
                        @select-all="selectAll">
                        <el-empty slot="empty" />
                        <el-table-column prop="dataSetName" label="数据集名称" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="type" label="数据集类型" show-overflow-tooltip>
                        </el-table-column>
                        <!-- <el-table-column prop="labelCode" label="标签" align="center" show-overflow-tooltip>
                        </el-table-column> -->
                        <el-table-column prop="remark" label="备注" show-overflow-tooltip />
                        <!--操作栏-->
                        <el-table-column label="操作" width="200">
                            <template v-if="showOperate(scope.row.type)" slot-scope="scope">
                                <el-button type="text" v-if="doEdit" class="bs-el-button-default"
                                    :disabled="scope.row.editable === 1 && !appCode" @click="
                                        toEdit(
                                            scope.row.id,
                                            scope.row.type,
                                            scope.row.dataSetName,
                                        )
                                        ">
                                    编辑
                                </el-button>
                                <el-button type="text" v-if="isDelete" class="bs-el-button-default"
                                    :loading="scope.row.loading" :disabled="scope.row.editable === 1 && !appCode"
                                    @click="delDataset(scope.row)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="bs-pagination">
                    <el-pagination class="bs-el-pagination" popper-class="bs-el-pagination" :current-page="current"
                        :page-sizes="[10, 20, 50, 100]" :page-size="size" :total="totalCount" background prev-text="上一页"
                        next-text="下一页" layout="total, prev, pager, next, sizes" @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle" />
                </div>
            </div>
        </el-row>
        <!-- 新增-类型窗口 -->
        <DatasetTypeDialog ref="DatasetTypeDialog" :dataset-type-list="datasetTypeList" @openAddForm="openAddForm" />
        <check-datasource ref="checkDatasource" :reason-list="reasonList" />
        <component :is="componentData.component" v-if="datasetType && componentData.component" ref="EditForm"
            :key="componentData.key" :config="componentData.config" :dataset-id="datasetId" :dataset-name="datasetName"
            :type-id="parentCode" :is-edit="isEdit" :app-code="appCode" @back="back">
            <template #output-field-table-column>
                <slot name="output-field-table-column" />
            </template>
        </component>
    </div>
</template>

<script>
import TypeTree from '@/components/data-room-ui/packages/dataSet/components/TypeTree.vue'
import JsonEditForm from '@/components/data-room-ui/packages/dataSet/components/JsonEditForm.vue'
import resizeTableHeight from '@/components/data-room-ui/packages/assets/js/utils/resizeHeightDirevtive.js'
import ScriptEditForm from '@/components/data-room-ui/packages/dataSet/components/ScriptEditForm.vue'
import CheckDatasource from '@/components/data-room-ui/packages/datasource/components/CheckDatasource.vue'
import CustomEditForm from '@/components/data-room-ui/packages/dataSet/components/CustomEditForm.vue'
import { pageMixin } from '@/components/data-room-ui/packages/assets/js/mixins/page.js'
import OriginalEditForm from '@/components/data-room-ui/packages/dataSet/components/OriginalEditForm.vue'
import HttpEditForm from '@/components/data-room-ui/packages/dataSet/components/HttpEditForm.vue'
import DatasetTypeDialog from '@/components/data-room-ui/packages/dataSet/components/DatasetTypeDialog.vue'
import StoredProcedureEditForm from '@/components/data-room-ui/packages/dataSet/components/StoredProcedureEditForm.vue'
export default {
    name: 'DataSetManagement',
    directives: {
        resizeTableHeight // 注册自定义指令
    },
    components: {
        TypeTree,
        DatasetTypeDialog,
        OriginalEditForm,
        CustomEditForm,
        JsonEditForm,
        StoredProcedureEditForm,
        ScriptEditForm,
        CheckDatasource,
        HttpEditForm
    },
    mixins: [pageMixin],
    props: {
        multiple: {
            type: Boolean,
            default: false
        },
        isDialog: {
            type: Boolean,
            default: false
        },
        dsValue: {
            type: [Array, Object],
            default: null
        },
        appCode: {
            type: String,
            default: ''
        },
        isBorder: {
            type: Boolean,
            default: false
        },
        toAdd: {
            type: Boolean,
            default: true
        },
        doEdit: {
            type: Boolean,
            default: true
        },
        isDelete: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            tabmaxheight: window.innerHeight - 290,
            reasonList: [],
            datasetType: null,
            isEdit: false,
            categoryData: [],
            tableData: [], // 表格数据
            // labelIds: [],
            queryForm: {
                dataSetName: '',
                enterprise: localStorage.getItem('enterprise_id'),
            }, // 查询条件
            // 数据集类型
            datasetTypeList: [],
            labelList: [],
            isPackUpTree: false,
            transition: 0.1,
            loadingText: '正在加载数据',
            dataListLoading: false,
            leftBox: null,
            rightBox: null,
            startX: null,
            event: null,
            endX: null,
            resize: null,
            datasetId: '', // 数据集Id，用于详情与编辑
            datasetName: '', // 数据集名称
            parentCode: '', // 详情typeId
            curRow: null,
            multipleSelection: [],
            // 远程组件
            componentData: {
                component: null,
                config: null,
                key: new Date().getTime()
            }
        }
    },
    computed: {
        allType() {
            return this.datasetTypeList
                .map((item) => item.datasetType)
                .filter((item) => item !== '')
        }
    },
    watch: {
        datasetType(value) {
            if (value === null) {
                this.datasetId = ''
                this.datasetName = ''
                this.isEdit = false
            }
        }
    },
    mounted() {
        window.addEventListener("resize", this.calculateTableHeight);
        this.init()
        if (
            /Safari/.test(navigator.userAgent) &&
            !/Chrome/.test(navigator.userAgent)
        ) {
            // 当前浏览器为Safari浏览器
            // 执行相关操作
            document.addEventListener('mousemove', function (event) {
                if (event.buttons === 1) {
                    event.preventDefault()
                }
            })
        }
    },
    methods: {
        calculateTableHeight() {
            // 根据视图高度计算表格高度的逻辑
            this.tabmaxheight = window.innerHeight - 290; // 示例：表格高度为窗口高度减去
            //.tabwidth = window.innerWidth - 290 + "px";
        },
        getLabels(list) {
            const arr = []
            list?.forEach((item) => {
                arr.push(this.labelList.filter((x) => x.id === item)[0]?.labelName)
            })
            return arr
        },
        toggleRowSelection() {
            this.$nextTick(() => {
                const dsIds = this.multipleSelection.map((ds) => ds.id)
                this.$refs.userTable.clearSelection()
                this.tableData.forEach((item) => {
                    if (dsIds.includes(item.id)) {
                        this.$refs.userTable.toggleRowSelection(item, true)
                    }
                })
            })
        },
        // 全选
        selectAll(selection) {
            if (this.isDialog && this.multiple) {
                if (selection.length) {
                    const dsIds = this.multipleSelection.map((ds) => ds.id)
                    selection.forEach((ds) => {
                        if (!dsIds.includes(ds.id)) {
                            this.multipleSelection.push(ds)
                        }
                    })
                } else {
                    this.tableData.forEach((row) => {
                        const dsIds = this.multipleSelection.map((ds) => ds.id)
                        const i = dsIds.indexOf(row.id)
                        if (i > -1) this.multipleSelection.splice(i, 1)
                    })
                }
            }
        },
        // 手动勾选
        selectDs(selection, row) {
            if (this.isDialog && this.multiple) {
                let dsIndex = null
                const ds = this.multipleSelection.find((ds, index) => {
                    if (ds.id === row.id) {
                        dsIndex = index
                        return ds
                    }
                })
                if (!ds) {
                    this.multipleSelection.push(row)
                } else {
                    this.multipleSelection.splice(dsIndex, 1)
                }
            }
        },
        // 获取选中数据集信息
        getSelectDs() {
            if (!this.isDialog) return
            if (this.multiple) {
                // 多选返回
                return this.multipleSelection
            } else {
                // 单选返回
                return this.curRow ? this.curRow : null
            }
        },
        // 单选数据集
        handleCurrentChange(currentRow) {
            this.curRow = currentRow
        },
        // 删除数据集
        delDataset(row) {
            this.$MessageBox.confirm('确定删除当前数据集吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'bs-el-message-box'
            })
                .then(() => {
                    this.$tools.asyncPost(this, this.$baseUrl.datasetdel, {
                        data: {
                            ids: Array(row.id)
                        }
                    }).then((res) => {
                        if (res.data.code == 0) {
                            this.$message({
                                showClose: true,
                                type: 'success',
                                message: res.data.msg
                            })
                            this.init(false)
                        } else {
                            this.$message({ showClose: true, type: "error", message: res.data.msg });
                        }
                    })
                })
                .catch(() => { })
        },
        // 详情
        toPreview(id, type, name, parentCode) {
            this.datasetId = id
            this.datasetType = type
            this.datasetName = name
            this.parentCode = parentCode
            this.isEdit = false
        },
        toEdit(id, type, name) {
            this.datasetId = id
            this.datasetType = type
            this.componentData =
                this.getComponents(
                    this.datasetTypeList.find((item) => item?.dictionary_value == type)
                        ?.dictionary_icon
                ) || ''

            this.datasetName = name
            this.isEdit = true
        },
        // 回到管理端
        back() {
            this.datasetType = null
            this.isEdit = false
        },
        // 新增数据集-类型
        openAddForm(type, componentName) {
            this.datasetType = type
            this.isEdit = true
            this.componentData = this.getComponents(componentName)
        },
        showOperate(datasetType) {
            return (
                this.getComponents(
                    this.datasetTypeList.find((type) => type.dictionary_value === datasetType)
                        ?.dictionary_icon
                )?.config?.showOperate ?? true
            )
        },
        getComponents(componentName) {
            const components = Object.values(this.$options.components)
            return {
                component: components.find((component) => (component.name == componentName || component.dataSetName == componentName)),
            }
        },
        // 初始化
        init() {
            this.getTreeList('BS-DATASET-TYPE')
            if (this.isDialog) {
                if (this.multiple) {
                    this.multipleSelection = this.dsValue ? this.dsValue : []
                } else {
                    this.curRow = this.dsValue
                }
            }
            this.current = 1
            // this.datasetTypeList = [
            //     { name: '全部', datasetType: '' },
            //     {
            //         name: '原始数据集',
            //         datasetType: 'original',
            //         componentName: 'OriginalEditForm',
            //         description: '直接查询某个数据库表'
            //     },
            //     {
            //         name: '自助数据集',
            //         datasetType: 'custom',
            //         componentName: 'CustomEditForm',
            //         description: '自定义SQL语句查询'
            //     },
            //     {
            //         name: '存储过程数据集',
            //         datasetType: 'storedProcedure',
            //         componentName: 'StoredProcedureEditForm',
            //         description: '调用数据库存储过程查询'
            //     },
            //     {
            //         name: 'JSON数据集',
            //         datasetType: 'json',
            //         componentName: 'JsonEditForm',
            //         description: '直接定义静态数据'
            //     },
            //     {
            //         name: 'HTTP数据集',
            //         datasetType: 'http',
            //         componentName: 'HttpEditForm',
            //         description: '接入第三方HTTP服务查询'
            //     },
            //     {
            //         name: '脚本数据集',
            //         datasetType: 'script',
            //         componentName: 'ScriptEditForm',
            //         description: '支持ES、Mongodb、国产化数据库、自定义Java代码查询'
            //     }
            // ]
            this.getDataList()
        },
        // 新增数据集
        addDataset() {
            this.$refs.DatasetTypeDialog.dialogVisible = true
        },
        selectChange() {
            this.getDataList()
        },
        getTreeList(code) {
            this.$tools
                .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
                    data: {
                        dictionary_code: code
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        this.datasetTypeList = res.data.data.dictionary_detail;
                        this.datasetTypeList.unshift({
                            dictionary_value: '全部', dictionary_key: ''
                        })
                    }
                }).catch((err) => { }).finally(() => {
                    this.pageLoading = false
                })
        },
        // 获取表格数据
        getDataList() {
            this.dataListLoading = true
            this.$tools.asyncPost(this, this.$baseUrl.datasetlist, {
                data: {
                    page: this.current,
                    limit: this.size,
                    type: this.queryForm.datasetType,
                    ...this.queryForm,

                }
            }).then((res) => {
                if (res.data.code == 0) {
                    this.tableData = res.data.data.data || []
                    this.tableData.forEach((r) => {
                        this.$set(r, 'loading', false)
                    })
                    if (this.isDialog) {
                        if (this.multiple && this.multipleSelection.length) {
                            this.toggleRowSelection()
                        } else if (this.curRow.id) {
                            const ds = this.tableData.find(
                                (item) => item.id === this.curRow.id
                            )
                            if (ds) this.curRow = ds
                        }
                    }
                    this.totalCount = res.data.data.total
                    this.dataListLoading = false
                } else {
                    this.$message({ showClose: true, type: "error", message: res.data.msg });
                }
            }).then(() => {
                this.dataListLoading = false
            })
        },
        expandedNodes(data) {
            if (data && data > 50) {
                this.transition = 0
            } else {
                this.transition = 0.1
            }
        },
        nodeClick(row, type) {
            this.current = 1
            const { id } = row
            if (type === 'group') {
                Object.assign(this.queryForm, { parentCode: id, type: '', })
            } else if (type === 'type') {
                Object.assign(this.queryForm, { parentCode: '', type: row, })
            } else if (type === 'tag') {
                Object.assign(this.queryForm, { parentCode: '', type: '', })
            }
            this.getDataList()
        },
        refreshData(node) {
            if (node && node.id === this.queryForm.parentCode) {
                this.queryForm.parentCode = ''
            }
            this.getDataList()
        },
        handleSearch() {
            this.current = 1
            this.queryForm.parentCode = ''
            // 清除左侧机构树的选中状态
            // this.$refs.datasetsTypeTree.dataroom-dataset-type-treeObj.cancelSelectedNode()
            this.getDataList()
        },
    }
}
</script>

<style lang="scss" scoped>
@import "./assets/css/index.scss";
@import "../assets/style/common.scss";
@import "./assets/css/treePackUp.scss";

::v-deep .big-screen-router-view-wrap {
    padding-left: 0px !important;
}

.bs-pagination {
    margin-top: 4px;
    padding-right: 16px;

    // padding: 0 !important;
    // right: 16px !important;
    // bottom: 16px !important;
    // position: absolute !important;
    ::v-deep .el-input__inner {
        width: 110px !important;
        border: none;
        // background: #151A26;
    }
}

.bs-container .inner-container .el-form .filter-item {
    ::v-deep .el-input__inner {
        width: 200px;
    }
}

::v-deep .left-tab-box {
    span {
        color: var(--bs-el-text);
    }
}

::v-deep .left-tab-box ul li.tab-active {
    background-color: rgba(64, 158, 255, 0.1);
}

::v-deep .left-tab-box ul li:hover {
    background-color: rgba(64, 158, 255, 0.1);
}

.el-dialog {
    .bs-container {
        // max-height: calc(90vh - 236px) !important;

        .el-table {
            height: 41vh;
            overflow: auto;
        }

        ::v-deep .dataroom-dataset-type-tree {
            max-height: calc(90vh - 325px) !important;
        }

        ::v-deep .el-tabs__item.is-active {
            border-bottom: none !important;
        }
    }
}

::v-deep .dataroom-dataset-type-treeNodeMenu {
    ul {
        background-color: #151a26;
    }

    li:hover {
        background-color: #303640;

        span {
            color: #409EFF;
        }
    }

    span {
        color: var(--bs-el-text);
    }

    .triangle {
        background-color: #151a26 !important;
    }
}

.layout {
    width: 100%;
    height: 100%;
}

// ::v-deep .el-table__body-wrapper {
//   max-height: unset !important;
// }
</style>
